/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brisk_Silver_Seal_RunInputs */

const en_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Success`)
};

const id_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berhasil`)
};

const ms_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berjaya`)
};

const ca_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Èxit`)
};

const cs_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úspěch`)
};

const da_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succes`)
};

const de_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfolgreich`)
};

const et_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Õnnestus`)
};

const es_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hecho`)
};

const fr_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succès`)
};

const hr_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uspjeh`)
};

const it_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operazione riuscita`)
};

const lv_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veiksmīgi`)
};

const lt_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pavyko`)
};

const hu_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sikerült`)
};

const nl_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelukt`)
};

const nb_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utført`)
};

const pl_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powodzenie`)
};

const pt_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sucesso`)
};

const ro_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succes`)
};

const sk_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úspech`)
};

const sl_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uspeh`)
};

const fi_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onnistui`)
};

const sv_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klart`)
};

const vi_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành công`)
};

const tr_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başarılı`)
};

const el_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επιτυχία`)
};

const bg_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Успех`)
};

const ru_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Готово`)
};

const sr_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Успех`)
};

const uk_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Успішно`)
};

const ka_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`წარმატება`)
};

const hi_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सफलता`)
};

const th_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สำเร็จ`)
};

const ko_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`성공`)
};

const zh_tw_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成功`)
};

const ja_brisk_silver_seal_run = /** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了`)
};

/** @type {(inputs: Brisk_Silver_Seal_RunInputs) => LocalizedString} */
const zh_brisk_silver_seal_run = en_brisk_silver_seal_run;

/**
* | output |
* | --- |
* | "Success" |
*
* @param {Brisk_Silver_Seal_RunInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const brisk_silver_seal_run = /** @type {((inputs?: Brisk_Silver_Seal_RunInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brisk_Silver_Seal_RunInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_brisk_silver_seal_run(inputs)
	if (locale === "ms") return ms_brisk_silver_seal_run(inputs)
	if (locale === "ca") return ca_brisk_silver_seal_run(inputs)
	if (locale === "cs") return cs_brisk_silver_seal_run(inputs)
	if (locale === "da") return da_brisk_silver_seal_run(inputs)
	if (locale === "de") return de_brisk_silver_seal_run(inputs)
	if (locale === "et") return et_brisk_silver_seal_run(inputs)
	if (locale === "es") return es_brisk_silver_seal_run(inputs)
	if (locale === "fr") return fr_brisk_silver_seal_run(inputs)
	if (locale === "hr") return hr_brisk_silver_seal_run(inputs)
	if (locale === "it") return it_brisk_silver_seal_run(inputs)
	if (locale === "lv") return lv_brisk_silver_seal_run(inputs)
	if (locale === "lt") return lt_brisk_silver_seal_run(inputs)
	if (locale === "hu") return hu_brisk_silver_seal_run(inputs)
	if (locale === "nl") return nl_brisk_silver_seal_run(inputs)
	if (locale === "nb") return nb_brisk_silver_seal_run(inputs)
	if (locale === "pl") return pl_brisk_silver_seal_run(inputs)
	if (locale === "pt") return pt_brisk_silver_seal_run(inputs)
	if (locale === "ro") return ro_brisk_silver_seal_run(inputs)
	if (locale === "sk") return sk_brisk_silver_seal_run(inputs)
	if (locale === "sl") return sl_brisk_silver_seal_run(inputs)
	if (locale === "fi") return fi_brisk_silver_seal_run(inputs)
	if (locale === "sv") return sv_brisk_silver_seal_run(inputs)
	if (locale === "vi") return vi_brisk_silver_seal_run(inputs)
	if (locale === "tr") return tr_brisk_silver_seal_run(inputs)
	if (locale === "el") return el_brisk_silver_seal_run(inputs)
	if (locale === "bg") return bg_brisk_silver_seal_run(inputs)
	if (locale === "ru") return ru_brisk_silver_seal_run(inputs)
	if (locale === "sr") return sr_brisk_silver_seal_run(inputs)
	if (locale === "uk") return uk_brisk_silver_seal_run(inputs)
	if (locale === "ka") return ka_brisk_silver_seal_run(inputs)
	if (locale === "hi") return hi_brisk_silver_seal_run(inputs)
	if (locale === "th") return th_brisk_silver_seal_run(inputs)
	if (locale === "ko") return ko_brisk_silver_seal_run(inputs)
	if (locale === "zh") return zh_brisk_silver_seal_run(inputs)
	if (locale === "zh-tw") return zh_tw_brisk_silver_seal_run(inputs)
	if (locale === "ja") return ja_brisk_silver_seal_run(inputs)
	return en_brisk_silver_seal_run(inputs)
});